import { Navigate, Outlet } from 'react-router-dom';
import { TOKEN_STORAGE_KEY } from '../../config';
import { useAuth } from '../../context/AuthContext';

export function ProtectedRoute() {
  const token = localStorage.getItem(TOKEN_STORAGE_KEY);
  const { user, loading } = useAuth();

  if (!token) return <Navigate to="/login" replace />;
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-onyx-muted">
        Loading secure session…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return <Outlet />;
}
